import script from "./AdminAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAbout.vue?vue&type=script&setup=true&lang=js"

import "./AdminAbout.vue?vue&type=style&index=0&id=44dd191e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44dd191e"]])

export default __exports__